import type { CoreRootState } from '../../../store/CoreStore';
import type { ILimit } from '../../../store/slices/bets/types';
import type { ChipValueType } from '../../../store/slices/chips/types';
import { ChipTypes } from '../../../store/slices/chips/types';

import type { HelpContextType } from './HelpContext';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type MapContextToStore<T extends Record<string, any> = Record<string, any>> = (state: CoreRootState) => T;

export interface PlacingBetsHelpContextProps {
  placingBets: {
    chips: ChipValueType[];
    currency: string;
    tableBetLimits: ILimit;
    tableNameKey: string;
    locale: string;
  };
}

export interface AutoCashingOutHelpContextProps {
  autoCashingOut: {
    maxMultiplier: number;
    locale: string;
  };
}

export interface AutoPlayHelpContextProps {
  autoPlay: {
    isInfiniteAutoPlayVisible: boolean;
  };
}
export interface ShowPPBrandingHelpContextProps {
  showPPBranding: boolean;
}

export const mapStateToHelpContextProps: MapContextToStore<HelpContextType> = (state) => {
  return {
    placingBets: {
      chips: state.chips.chips
        .filter((chip) => chip.type === ChipTypes.CasinoChip)
        .map((chip) => ({ ...chip, disabled: false })),
      currency: state.gameState.currency ?? 'EUR',
      tableBetLimits: state.config.tableConfig?.tableBetLimit ?? { min: 0.1, max: 5000 },
      tableNameKey: state.config.tableConfig?.tableName ?? '',
      locale: state.settings.language.current,
    },
    autoCashingOut: {
      maxMultiplier: state.config.tableConfig?.maxMultiplier ?? 100,
      locale: state.settings.language.current,
    },
    autoPlay: {
      isInfiniteAutoPlayVisible: state.config.tableConfig?.isInfiniteAutoPlayEnabled ?? false,
    },
    showPPBranding: state.config.tableConfig?.showPPBranding ?? false,
  };
};
